import {connect} from "react-redux"
import {createSelector} from "reselect"
import {CurrencyConfiguration} from "@next/utils"
import {setSelectedPriceFilterAction} from "../../ducks/search"
import {searchForSelectedPrice} from "../../ducks/tabbedFilters"
import State from "../../models/State"
import getLocaleFromHeaders from "../../utils/getLocaleFromHeaders"
import getRealmFromHeaders from "../../utils/getRealmFromHeaders"
import {FilterPrice} from "../../models/Filter"

type OwnProps = {
    name: string
    isTabbedFilter?: boolean
    updatePriceFilters?: ({
        name,
        isTabbedFilter,
        selectedMin,
        selectedMax,
    }: {
        name: string
        isTabbedFilter: boolean
        selectedMin: number
        selectedMax: number
    }) => void
    globalPriceFormattingConfig?: CurrencyConfiguration
}

// Selector for facet
const selectFacet = (state: State, ownProps: OwnProps) => state.search.filters[ownProps.name] as FilterPrice

// Memoized selector for currentSelectedValues
const makeSelectCurrentSelectedValues = createSelector([selectFacet], facet => [
    facet.selectedMin ?? facet.min,
    facet.selectedMax ?? facet.max,
])

export const mapStateToProps = (state: State, ownProps: OwnProps) => {
    const facet = selectFacet(state, ownProps)
    const {headers} = state.request
    const locale = getLocaleFromHeaders(headers)
    const realm = getRealmFromHeaders(headers)
    const {text, template} = state
    return {
        min: facet.min,
        max: facet.max,
        currentSelectedValues: makeSelectCurrentSelectedValues(state, ownProps),
        currencyCode: facet.currencyCode,
        locale,
        realm,
        text,
        globalPriceFormattingConfig: state.search.globalPriceFormattingConfig,
        templating: template,
        ...ownProps,
    }
}

export const mapDispatchToProps = (dispatch: any) => ({
    updatePriceFilters: ({
        name,
        isTabbedFilter,
        selectedMin,
        selectedMax,
    }: {
        name: string
        isTabbedFilter: boolean
        selectedMin: number
        selectedMax: number
    }) => {
        if (isTabbedFilter) {
            dispatch(searchForSelectedPrice(name, selectedMin, selectedMax))
        } else {
            dispatch(setSelectedPriceFilterAction(name, selectedMin, selectedMax))
        }
    },
})

export default connect(mapStateToProps, mapDispatchToProps)
